type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'CreditLine'
const nameSource = 'commercial/creditLines'
const namePageTitle = 'Linhas de Créditos'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Cadastro',
  to: '/commercial/creditLines',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/commercial/creditLines/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/creditLines/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Atualizar',
    to: '/commercial/creditLines/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
